






























































import { Component, Vue } from 'vue-property-decorator'
import { queryDictsByCode, addShare, querySelfShare, releaseShare, deleteShare } from '@/api/api'
import moment from 'moment'
import axios from 'axios'

@Component({})
export default class CourseUpload extends Vue {
  courseData: Array<any> = []
  pageSize: number = 5 // 分页组件的page-size
  total: number = 0 // 分页组件的total
  dialogFormVisible: boolean = false // 弹出框是否可见
  fileTypeList: Array<any> = [] // 分享类型
  form: any = {
    file: '', // 上传文件
    fileType: '', // 上传文件后缀
    fileName: '',
    shareType: '',
    shareName: '',
    describe: '',
    imgFile: ''
  }
  formLabelWidth = '120px'
  fileList: any = []

  mounted() {
    this._onload()
  }

  /**
   * 上传课程
   */
  async uploadCourse(): Promise<any> {
    this._loading()
    await this._addShare()
    this._loading().close()
  }

  /**
   * 查看文件
   */
  openFile(file: any): void {
    window.open(file.linkUrl)
  }

  /**
   * 发布共享
   */
  releaseFile(file: any): void {
    this.$confirm(`确定要发布 ${file.name} 吗`).then(() => {
      this._releaseShare(file.id, '0')
    })
  }

  /**
   * 删除共享
   */
  delFile(file: any): void {
    this.$confirm(`确定要删除 ${file.name} 吗`, {
      type: 'error'
    }).then(() => {
      this._deleteShare(file.id, file.state)
    })
  }

  /**
   * 换页
   */
  async changePage(page: number): Promise<any> {
    this._loading()
    await this._querySelfShare(page)
    this._loading().close()
  }

  uploadCover(options: any): any {
    let file = options.file
    let filename = file.name
    const fileType = file.name.split('.')
    const reader = new FileReader()
    if (file) {
      reader.readAsDataURL(file)
    }
    reader.onload = () => {
      this.form.imgFile = reader.result
    }
  }

  /**
   * 上传文件
   */
  uploadFile(options: any): void {
    const vm = this
    let file = options.file
    let filename = file.name
    const fileType = file.name.split('.')
    const reader = new FileReader()

    if (file) {
      reader.readAsDataURL(file)
    }
    reader.onload = () => {
      let base64Str: any = reader.result
      this.form.file = base64Str.split(',')[1]
      this.form.fileName = filename
      this.form.fileType = fileType[fileType.length - 1]
    }
  }

  /**
   * 状态转译成中文
   */
  stateToCn(state: '0' | '1'): any {
    const Dic = {
      '0': '已发布',
      '1': '未发布'
    }
    return Dic[state]
  }

  /**
   * 页面初始化
   */
  async _onload(): Promise<any> {
    this._loading()

    const fileTypeList = JSON.parse(sessionStorage.dictionary)[1].children
    for (let i = 0; i < fileTypeList.length; i++) {
      this.fileTypeList.push({
        label: fileTypeList[i].code_value,
        value: fileTypeList[i].code
      })
    }

    await this._querySelfShare()
    this._loading().close()
  }

  /**
   * 接口 添加分享
   * @param file       文件
   * @param file_type  文件后缀
   * @param type_code  分享类型
   * @param share_name 分享名字
   * @param share_desc 分享介绍
   * @param share_id   课程ID
   */
  async _addShare(): Promise<any> {
    return addShare({
      file: this.form.file,
      file_type: this.form.fileType,
      type_code: this.form.shareType,
      share_name: this.form.shareName,
      share_desc: this.form.describe,
      imgFile: this.form.imgFile
    }).then((res: any) => {
      // load.close()
      if (res.data.code === 101) {
        this.$message.success('上传成功')
        this.form = {
          file: '',
          fileType: '',
          fileName: '',
          shareType: ''
        }
        this._querySelfShare()
        this.dialogFormVisible = false
      }
    })
  }

  /**
   * 接口 发布分享
   * @param share_id 分享ID
   * @param states   发布状态：0已发布 1：未发布
   */
  _releaseShare(id: string, state: string): void {
    this._loading('发布中')
    releaseShare({
      share_id: id,
      states: state
    })
      .then(async (res: any) => {
        if (res.data.code === 101) {
          await this._querySelfShare()
          this.$message.success('发布成功')
        } else {
          this.$message.warning(res.data.message)
        }
      })
      .catch(() => {
        this.$message.error('网络错误，请重试！')
      })
      .finally(() => {
        this._loading().close()
      })
  }

  /**
   * 接口 删除分享
   * @param share_id 分享ID
   * @param states   发布状态：0已发布 1：未发布
   */
  _deleteShare(id: string, state: string): void {
    this._loading('删除中')
    deleteShare({
      share_id: id,
      states: state
    })
      .then(async (res: any) => {
        if (res.data.code === 101) {
          await this._querySelfShare()
          this.$message.success('删除成功')
        } else {
          this.$message.warning(res.data.message)
        }
      })
      .catch(() => {
        this.$message.error('网络错误，请重试！')
      })
      .finally(() => {
        this._loading().close()
      })
  }

  /**
   * 接口 查询自己分享
   * @param page 页数
   * @param size 每页数量
   */
  async _querySelfShare(page: number = 1, size: number = this.pageSize): Promise<any> {
    return querySelfShare({
      page,
      size
    })
      .then((res: any) => {
        if (res.data.code === 101) {
          const arr = res.data.result.records
          this.total = res.data.result.total
          this.courseData = []
          for (let i = 0, len = arr.length; i < len; i++) {
            this.courseData.push({
              id: arr[i].shareId,
              name: arr[i].shareName,
              type: this._codeToCn(arr[i].typeCode),
              date: moment(arr[i].create_time).format('YYYY.MM.DD'),
              describe: arr[i].shareDesc,
              // state: this._stateToCn(arr[i].shareStatus),
              state: arr[i].shareStatus,
              linkUrl: arr[i].linkUrl
            })
          }
        }
      })
      .catch(_ => {
        this.$message.error('网络出错，请重试！')
      })
  }

  /**
   * 获取分享类型
   */
  async _queryDictsByCode(): Promise<any> {
    const load = this.$loading({
      lock: true,
      text: '加载中',
      background: 'rgba(0, 0, 0, 0.7)'
    })
    return queryDictsByCode({ parent_code: 'share' })
      .then((res: any) => {
        load.close()
        if (res.data.code === 101) {
          const arr = res.data.result
          for (let i = 0, len = arr.length; i < len; i++) {
            this.fileTypeList.push({
              label: arr[i].code_value,
              value: arr[i].code
            })
          }
        }
      })
      .catch(_ => {
        load.close()
      })
  }

  /**
   * 选项值转译成中文
   */
  _codeToCn(code: string): any {
    const arr = this.fileTypeList
    for (let i = 0, len = arr.length; i < len; i++) {
      if (code == arr[i].value) {
        return arr[i].label
      }
    }
  }

  /**
   * 显示loading
   */
  _loading(text: string = '加载中'): any {
    const vm = this

    this.$loading({
      lock: true,
      text: text,
      background: 'rgba(0, 0, 0, 0.7)'
    })

    return {
      close() {
        vm.$loading({}).close()
      }
    }
  }
}
